module.exports = __webpack_public_path__ + "static/media/jumbo_banner_1.270ecff6.jpg";